import customAxiosInterceptor from "../customAxiosInterceptor";

export const searchTermThunk = async (searchTerm: string, thunkAPI: any) => {
  try {
    const response = await customAxiosInterceptor.get(
      `/search?search_term=${searchTerm}`
    );
    return thunkAPI.fulfillWithValue(response.data.data);
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};

export const searchPageTermThunk = async (
  { searchTerm, maxPrice, minPrice, order, take, page }: any,
  thunkAPI: any
) => {
  try {
    let url = `/search/page?search_term=${searchTerm}`;
    if (maxPrice) {
      url += `&max_price=${maxPrice}`;
    }
    if (minPrice) {
      url += `&min_price=${minPrice}`;
    }
    if (order) {
      url += `&order=${order}`;
    }
    if (take) {
      url += `&take=${take}`;
    }
    if (page) {
      url += `&page=${page}`;
    }
    const response = await customAxiosInterceptor.get(url);
    return thunkAPI.fulfillWithValue(response.data);
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};
